import { GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, UPDATE_MANY, DELETE, DELETE_MANY, } from 'ra-core';
export var QUERY_TYPES = [GET_LIST, GET_MANY, GET_MANY_REFERENCE, GET_ONE];
export var MUTATION_TYPES = [
    CREATE,
    UPDATE,
    DELETE,
    UPDATE_MANY,
    DELETE_MANY,
];
export var ALL_TYPES = QUERY_TYPES.concat(MUTATION_TYPES);
//# sourceMappingURL=constants.js.map